import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {SkWaveComponent, SpinnerVisibilityService} from "ng-http-loader";
import {MesHttpStatusHandlerService} from "../mes-http-status-handler.service";
import {BaseComponent} from "../base-component";
import {takeUntil} from "rxjs/operators";
import {BehaviorSubject, ReplaySubject} from "rxjs";

@Component({
  selector: 'mes-web-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent extends SkWaveComponent implements OnInit, OnDestroy {
  @ContentChild('valueTemplate') valueTemplate: TemplateRef<any>;
  @Input() color = "#ff0000";
  urls$ = new BehaviorSubject<string[]>([]);
  protected componentDestroyed: ReplaySubject<void> = new ReplaySubject<void>(1);

  constructor(private spinner: SpinnerVisibilityService, public mesHttpStatusHandlerService: MesHttpStatusHandlerService) {
    super();
    this.backgroundColor = this.color;
    this.mesHttpStatusHandlerService.urls.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      setTimeout(() => {
        this.urls$.next(value);
      }, 0);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (!this.componentDestroyed.closed) {
      this.componentDestroyed.next();
      this.componentDestroyed.complete();
    }
    this.componentDestroyed.unsubscribe();
  }

  close() {
    this.spinner.hide();
  }
}
